import React, { useEffect, useState } from "react";
import ModalComponent from "@/components/modal";
import { Flex, Form, Select } from "antd";
import ButtonComponent from "@/components/button/Button";
import TextArea from "antd/es/input/TextArea";
import { keyFilterOption } from "@/helpers";
import { getReportCategory } from "@/services/users/getReportCategory";

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: "red" }}>*</span>}
  </>
);

const Report = ({ isOpen = false, categoryType = "Product", handleSubmit = () => {} }) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [categoryList, setCategoryList] = useState([]);

  const handleFinish = (data) => {
    handleSubmit(data);
  };

  useEffect(() => {
    getReportCategory()
      .then((res) => {
        const filteredData = res.filter((x) => x.category === categoryType);
        setCategoryList(filteredData.map((x) => ({ value: x.id, label: x.title })));
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <ModalComponent isOpen={isOpen} width={500}>
      <Flex vertical gap="1rem">
        <Flex align="center" justify="center">
          <img src="/assets/images/report.svg" alt="" />
        </Flex>
        <Form
          name="document"
          form={form}
          initialValues={{ remember: false }}
          layout="vertical"
          size="small"
          onFinish={handleFinish}
          requiredMark={customizeRequiredMark}
          className="report-form"
        >
          <Form.Item
            name="categoryId"
            rules={[
              {
                required: true,
                message: "Please select a category!",
              },
            ]}
          >
            <Select
              virtual={false}
              showSearch
              className="report-category-select"
              placeholder="Select Category"
              filterOption={keyFilterOption}
            >
              {categoryList.map((category) => (
                <Option
                  key={category.value} // Updated key to use value instead of label for uniqueness
                  value={category.value}
                  label={category.label}
                >
                  <Flex justify="start" align="center" gap="5px">
                    <span>{category.label}</span>
                  </Flex>
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Add Description"
            name="description"
            className="report-description"
            rules={[
              {
                required: true,
                message: "Please enter description!",
              },
            ]}
          >
            <TextArea
              autoSize={{ minRows: 4, maxRows: 7 }}
              style={{
                padding: "10px",
              }}
              placeholder="Enter your description..."
            />
          </Form.Item>
          <Form.Item>
            <div className="button">
              <ButtonComponent
                label="Submit Report"
                varient="primary"
                className="w-100"
                htmlType="submit"
              />
            </div>
          </Form.Item>
        </Form>
      </Flex>
    </ModalComponent>
  );
};

export default Report;
